import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
import dayjs from 'dayjs';
import { UtilityService } from '../utility_functions/utility_functions.service';
import { LocalStorageService } from '../localstorage.service';

@Injectable({
    providedIn: 'root'
})
export class TimesheetsService {
    get timesheetURL(): any{
        return `${this.datacollectorservice.baseurl()}/timesheet`;
    }
    get timesheetsURL(): any{
        return `${this.datacollectorservice.baseurl()}/timesheets`;
    }
    get requestTypeUrl(): any{
        return `${this.datacollectorservice.baseurl()}/timesheet/request/timeoff_type`;
    }
    get timeoffUrl(): any{
        return `${this.datacollectorservice.baseurl()}/timesheets/request/timeoff`;
    }
    get timesheetApprovalUrl(): any{
        return `${this.datacollectorservice.baseurl()}/timesheet/approval`;
    }
    get checkinUrl(): any{
        return `${this.timesheetURL}s?bypass_check=true`;
    }
    get defaultersUrl(): any{
        return `${this.timesheetURL}s/yet_to_update`;
    }
    get userShiftUrl(): any{
        return `${this.datacollectorservice.baseurl()}/timesheet/user_shifts?`;
    }
    get masterShiftsUrl(): any{
        return `${this.datacollectorservice.baseurl()}/timesheet/master_shifts`;
    }
    get rruleUrl(): any{
        return `${this.datacollectorservice.baseurl()}/timesheet/master_shift/recurring_rules`;
    }
    get teamsSummaryURL(): any{
        return `${this.datacollectorservice.baseurl()}/teams/summary`;
    }
    get historyAvailabilityUrl(): any{
        return `${this.datacollectorservice.baseurl()}/timesheets/history_availability`;
    }
    get enrollmentBaseUrl(): any{
        return `${this.datacollectorservice.baseurl()}/timesheets/enrollments`;
    }
    refreshUserShiftData: ReplaySubject<any> = new ReplaySubject(1);

    timesheetApprovalUrls = {
        dataUrl: `${this.timesheetURL}/approval/filter`,
        filterUrl: `${this.timesheetURL}/approval/meta/filter`
    };
    refreshTimeOff: ReplaySubject<any> = new ReplaySubject<any>(1);
    locationApiUrls: any = {
        dataUrl: `${this.timesheetURL}/location`
    };

    enrollmentsApiUrls: any = {
        columnUrl: `${this.enrollmentBaseUrl}/meta`,
        dataUrl: `${this.enrollmentBaseUrl}/filter`,
        filterUrl: `${this.enrollmentBaseUrl}/meta/filter`,
    };

    timesheetApiUrl: any = {
        dataUrl: `${this.timesheetURL}s/filter`,
        filterUrl: `${this.timesheetURL}s/meta/filter`
    };

    timeOffUrls: any = {
        pendingApprovalUrl: `${this.timesheetURL}s/request/timeoff?filter.approval_status=PENDING`,
        timeofflist: `${this.timesheetURL}s/request/timeoff`
    };

    constructor(
        private http: HttpClient,
        private datacollectorservice: DataCollectorService,
        private utilityService: UtilityService,
        private _localStorageService: LocalStorageService) {
            this.refreshUserShiftData.next(false);
        }

    createTimesheetUrl(): any {
        return `${this.timesheetURL}s/bulk_update`;
    }

    deleteLocation(locationUid): any {
        const locationURL = `${this.timesheetURL}/location/${locationUid}`;
        return this.datacollectorservice.deleteData(locationURL);
    }

    deleteTimesheet(timesheetUid, remarks = ''): any {
        const timesheetURL = `${this.timesheetURL}s?employee_timesheet_uid=${timesheetUid}&remarks=${remarks}`;
        return this.datacollectorservice.deleteData(timesheetURL);
    }
    updateTimesheet(timesheetUid, data): any {
        const timesheetURL = `${this.timesheetURL}s/${timesheetUid}/update`;
        return this.datacollectorservice.putData(timesheetURL, data);
    }

    getTeamsBasedOnUser(userID): string {
        return `${this.datacollectorservice.baseurl()}/user/${userID}/teams`;
    }

    getTimeoffUpdateApproval(requestId: any): string {
        return `${this.timeOffUrls?.timeofflist}/${requestId}/update_approval`;
    }
    getTimeoffDeleteUrl(requestId: any): string {
        return `${this.timeOffUrls?.timeofflist}/${requestId}`;
    }

    getTimesheetApprovalDetail(approvalId: any): string {
        return `${this.timesheetApprovalUrl}/${approvalId}`;
    }

    getTimesheetHistory(): string {
        return `${this.timesheetURL}s/history_details`;
    }

    getUpdateUserShiftUrl(shiftId: any): any {
        return `${this.timesheetURL}/user_shifts/${shiftId}`;
    }

    getApprovalUrl(approvalId: any): string{
        return `${this.timesheetURL}/approval/${approvalId}/status`;
    }

    getTeamDetails(teamUid): string{
        return `${this.datacollectorservice.baseurl()}/team/${teamUid}`;
    }

    getDateValue(date,type): any{
        switch(type){
          case 'date':
            return dayjs(date).format('DD MMM');
          case 'day':
            return dayjs(date).format('dddd');
        }
      }

    getTeamsUrl(): string {
        return `${this.datacollectorservice.baseurl()}/team`;
    }
}
